module.exports = __webpack_public_path__ + "static/media/big-white-send.261c0f72.svg";